import CryptoJS from 'crypto-js';

export const hash = async (text: string) => {
  const hashed = CryptoJS.MD5(text).toString();
  return hashed;
};
